(() => {
  if (window.__clasioFastAddV3) return;
  window.__clasioFastAddV3 = true;

  const CART_POLL_MS = 650;
  let dialog;
  let frame;
  let loader;
  let opener = null;
  let initialCartCount = null;
  let cartTimer = null;
  let cartHandled = false;

  const init = () => {
    dialog = document.getElementById('ClasioFastAddDialog');
    frame = document.getElementById('ClasioFastAddFrame');
    if (!dialog || !frame) return;

    loader = dialog.querySelector('[data-clasio-fast-add-loading]');

    document.addEventListener('click', onDocumentClick, true);
    dialog.addEventListener('click', onDialogClick);
    dialog.addEventListener('cancel', onDialogCancel);
    frame.addEventListener('load', onFrameLoad);
  };

  const onDocumentClick = (event) => {
    const trigger = event.target.closest('.clasio-fast-add-trigger');
    if (!trigger || trigger.disabled) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    open(trigger);
  };

  const onDialogClick = (event) => {
    if (event.target === dialog || event.target.closest('[data-clasio-fast-add-close]')) {
      event.preventDefault();
      close(false);
    }
  };

  const onDialogCancel = (event) => {
    event.preventDefault();
    close(false);
  };

  const setTriggerLoading = (button, isLoading) => {
    if (!button) return;
    button.classList.toggle('is-loading', isLoading);
    const spinner = button.querySelector('.clasio-fast-add-trigger__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  };

  const buildUrl = (productUrl) => {
    const url = new URL(productUrl, window.location.origin);
    const current = new URL(window.location.href);
    ['preview_theme_id', '_ab', '_fd', '_sc', 'pb'].forEach((key) => {
      const value = current.searchParams.get(key);
      if (value !== null) url.searchParams.set(key, value);
    });
    url.searchParams.set('clasio_fast_add', '1');
    return url.toString();
  };

  const getCartCount = async () => {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return null;
      const cart = await response.json();
      return Number(cart.item_count || 0);
    } catch (error) {
      return null;
    }
  };

  const open = async (button) => {
    if (!dialog || !frame) return;
    const productUrl = button.getAttribute('data-clasio-fast-add-url');
    if (!productUrl) return;

    if (dialog.open) close(false);

    opener = button;
    cartHandled = false;
    initialCartCount = await getCartCount();
    setTriggerLoading(button, true);
    if (loader) loader.classList.remove('is-hidden');

    document.documentElement.classList.add('clasio-fast-add-lock');
    document.body.classList.add('clasio-fast-add-lock');

    dialog.showModal();
    frame.src = buildUrl(productUrl);
  };

  const stopCartWatch = () => {
    if (!cartTimer) return;
    window.clearInterval(cartTimer);
    cartTimer = null;
  };

  const startCartWatch = () => {
    stopCartWatch();
    if (initialCartCount === null) return;

    cartTimer = window.setInterval(async () => {
      if (cartHandled || !dialog.open) return;
      const current = await getCartCount();
      if (current !== null && current !== initialCartCount) handleCartChanged();
    }, CART_POLL_MS);
  };

  const refreshParentCart = async () => {
    try {
      const response = await fetch('/cart?sections=cart-drawer,cart-icon-bubble', {
        credentials: 'same-origin'
      });
      if (!response.ok) return;
      const sections = await response.json();

      if (sections['cart-icon-bubble']) {
        const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const fresh = doc.querySelector('#cart-icon-bubble');
        const current = document.querySelector('#cart-icon-bubble');
        if (fresh && current) current.replaceWith(fresh);
      }

      if (sections['cart-drawer']) {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          const freshDrawer = doc.querySelector('cart-drawer');
          if (freshDrawer) drawer.innerHTML = freshDrawer.innerHTML;
        }
      }
    } catch (error) {
      console.warn('Clasio Fast Add cart refresh:', error);
    }
  };

  const openParentCart = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:open'));
  };

  const handleCartChanged = async () => {
    if (cartHandled) return;
    cartHandled = true;
    stopCartWatch();
    await refreshParentCart();
    close(true);
  };

  const close = (openCart) => {
    stopCartWatch();
    if (dialog && dialog.open) dialog.close();

    try { frame.src = 'about:blank'; } catch (error) {}
    if (loader) loader.classList.remove('is-hidden');
    setTriggerLoading(opener, false);

    document.documentElement.classList.remove('clasio-fast-add-lock');
    document.body.classList.remove('clasio-fast-add-lock');

    const focusTarget = opener;
    opener = null;
    initialCartCount = null;
    cartHandled = false;

    if (openCart) {
      window.setTimeout(openParentCart, 100);
    } else if (focusTarget && typeof focusTarget.focus === 'function') {
      window.setTimeout(() => focusTarget.focus(), 40);
    }
  };

  const onFrameLoad = () => {
    if (!dialog || !dialog.open) return;

    try {
      const win = frame.contentWindow;
      const doc = frame.contentDocument;
      if (!win || !doc || !doc.head || !doc.body) return;

      const path = win.location.pathname;
      if (path === '/cart' || path.startsWith('/cart/')) {
        handleCartChanged();
        return;
      }

      injectFrameStyles(doc);
      win.scrollTo(0, 0);

      if (loader) loader.classList.add('is-hidden');
      setTriggerLoading(opener, false);
      startCartWatch();
    } catch (error) {
      console.error('Clasio Fast Add iframe:', error);
      setTriggerLoading(opener, false);
    }
  };

  const injectFrameStyles = (doc) => {
    let style = doc.getElementById('clasio-fast-add-frame-style');
    if (!style) {
      style = doc.createElement('style');
      style.id = 'clasio-fast-add-frame-style';
      doc.head.appendChild(style);
    }

    /* Qikify/Tepo and the Shopify product form are intentionally untouched. */
    style.textContent = `
      html, body { background: #fff !important; overflow-x: hidden !important; }
      body { margin: 0 !important; }

      .shopify-section-group-header-group,
      .shopify-section-group-footer-group,
      #shopify-section-announcement-bar,
      #shopify-section-header,
      .header-wrapper,
      .announcement-bar,
      cart-drawer,
      cart-notification,
      sticky-atc,
      .sticky-atc,
      product-recommendations,
      .product-recommendations,
      .related-products,
      .recently-viewed,
      #clasio-campaign-popup,
      .clasio-whatsapp-button,
      [id*="shopify-section-scroll-to-top-btn"],
      [id*="shopify-section-global-music-player"] {
        display: none !important;
      }

      #MainContent, main { margin-top: 0 !important; padding-top: 0 !important; }
      section[id^="MainProduct-"] { margin-top: 0 !important; }
      section[id^="MainProduct-"] > .page-width {
        max-width: 1120px !important;
        margin: 0 auto !important;
        padding: 28px 34px 38px !important;
      }

      /* Keep the fast-add view focused on purchasing without touching Tepo. */
      .soft-policy-container,
      .custom-accordion,
      .product__description,
      .product__view-details,
      .shopify-payment-button {
        display: none !important;
      }

      @media screen and (min-width: 750px) {
        section[id^="MainProduct-"] .product { align-items: flex-start !important; }
        section[id^="MainProduct-"] .product__media-wrapper,
        section[id^="MainProduct-"] .product__info-wrapper {
          position: relative !important;
          top: auto !important;
        }
      }

      @media screen and (max-width: 749px) {
        section[id^="MainProduct-"] > .page-width {
          padding: 20px 16px 30px !important;
        }
      }
    `;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
